import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

interface Contact {
  contact_id: string
  phone: string
  name: string
  tags: string[]
  notes: string
  metadata: Record<string, any>
  created_at: string
  updated_at: string
  created_by: string
}

type QueryResponse = {
  timestamp: string;
  status: number;
  data: {
    contacts: Contact[]
  };
};

export const createListContactsKey = (additional: any[] = []) => [
  'list-contacts',
  ...additional,
];

export const useListContactsQuery = (additionalProps = {}) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while Listing WhatsApp Contacts',
    endpoint: `/api/admin/whatsapp/contacts`,
  });

  return useQuery({
    queryKey: createListContactsKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};